import styled from "@emotion/styled";
import { Accordion, AccordionDetails, AccordionSummary, Skeleton } from "@mui/material";

export const Heading = styled.h2(({ theme }) => ({
	...theme.project.typography.heading.h4,
	color: theme.project.colors.fontColors.main,
	fontWeight: 200,
	fontsize: "34px",
	lineHeight: "124%",
	letterSpacing: "1px",
	margin: 0
}));

export const Panel = styled.section(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	border: theme.project.borders.presets.thinOutline,
	display: "flex",
	flexDirection: "column",
	gap: 12,
	padding: 16
}));

export const Question = styled(Accordion)(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	border: theme.project.borders.presets.thinOutline,
	boxShadow: theme.shadows[1],
	margin: 0,

	"&::before": {
		display: "none"
	},

	"&.Mui-expanded": {
		margin: 0
	}
}));

export const Summary = styled(AccordionSummary)(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.primaryColors.main,
	fontWeight: 500,
	minHeight: 44,
	padding: "0 16px",
	fontsize: "20px",
	lineHeight: "160%",
	letterSpacing: "0.15px",

	"& .MuiAccordionSummary-content": {
		margin: "8px 0"
	},

	"& .MuiAccordionSummary-expandIconWrapper": {
		color: theme.project.colors.primaryColors.main
	}
}));

export const Answer = styled(AccordionDetails)(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.main,
	overflowWrap: "anywhere",
	padding: "0 16px 16px",
	fontsize: "16px",
	fontWeight: 400,
	lineHeight: "150%",
	letterSpacing: "0.15px",

	"& b, & strong": {
		fontWeight: 500
	},

	"& > :first-child": {
		marginTop: 0
	},

	"& > :last-child": {
		marginBottom: 0
	},

	"& a": {
		color: theme.project.colors.primaryColors.main,
		textDecoration: "underline"
	}
}));

export const LoadingRow = styled(Skeleton)({
	height: 44,
	transform: "none"
});
